import { graphql } from '../../graphql';

export const getRegions = graphql(`
  query Regions($cityId: ID!) {
    regions(cityId: $cityId) {
      id
      name
      latitude
      longitude
      slug
    }
  }
`);
